import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {takeUntil, tap} from 'rxjs/operators';

import {Destroyable} from '../../destroyable.component';
import {TemplateAvailability} from '../../shared/documents/documents.interface';
import {Contract} from '../../shared/employees/employees.model';
import {ESSService} from '../employee-self.service';

@Component({
  selector: 'ess-my-documents',
  templateUrl: './my-documents.component.html',
  styleUrls: ['./my-documents.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MyDocumentsComponent extends Destroyable implements OnInit {

  public static ACCESS_NAME = 'ESSMyDocuments';
  public TemplateAvailability = TemplateAvailability;
  public selectedContract: Contract;

  constructor(public essService: ESSService) {
    super();
  }

  public ngOnInit() {
    this.essService.currentContract
      .pipe(
        tap((contract: Contract) => this.selectedContract = contract),
        takeUntil(this.componentDestroyed$)
      )
      .subscribe();
  }

}
